<template>
  <div class="page_container storageManeagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >基础设置&客服帮助</el-breadcrumb-item
        >
        <el-breadcrumb-item>仓储资源管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl" @click="handleAddOne">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="listData.length > 0">
          <div class="item_wrap" v-for="item in listData" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap">
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      仓库名称：<span>{{ item.whname }}</span>
                    </p>
                    <p>
                      货架数量：<span>{{ item.shelfNum }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      货架总层数：<span>{{ item.shelfColumnNum }}</span>
                    </p>
                    <p>
                      所属企业：<span>{{ item.qyname }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="editBtn" @click="handlEdit(item.id)">
                  修改仓库名称→
                </div>
                <div class="editBtn" @click="handleGo(item.id)">管理仓库→</div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="尚未添加仓库"
          v-if="!loading && listData.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 弹窗 start -->
    <el-dialog title="仓库名称" :visible.sync="isShow" width="30%">
      <div class="input_box">
        <el-input v-model="name" placeholder="输入仓库名称"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">{{
          isEdit ? "保存" : "确 认"
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗 end -->
  </div>
</template>

<script>
import {
  getMenuAuthTwo,
  getWearhouseList,
  addWearhouse,
  editWearhouse,
} from "../../api/api";
export default {
  name: "sManageIndex",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      qyid: 0,

      editId: "",
      isShow: false, // 弹窗是否显示
      isEdit: false, // 弹窗是否编辑
      name: "", // 仓库名称

      loading: false,
      listData: [],
    };
  },
  created() {
    this.init();
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyid = userInfo.qy.id;
    } else {
      this.qyid = 0;
    }

    this.roleId = this.$store.state.USERINFO.qy.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    init() {
      this.loading = true;
      let parasm = {
        openid: this.$store.state.OPENID,
      };

      getWearhouseList(parasm).then((res) => {
        if (res.length > 0) {
          let dataNew = res;
          dataNew.map((v1) => {
            // 货架数量
            v1.shelfNum = v1.childs2.length;
            v1.shelfColumnNum = 0;
            // 货架总层数
            v1.childs2.forEach((v2) => {
              v1.shelfColumnNum += v2.childs3.length;
            });
          });
          this.loading = false;
          this.listData = dataNew;
        }else {
          this.loading = false;
          this.listData = [];
        }
      });
    },

    // 新增仓库
    handleAddOne() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }
      this.name = "";
      this.isEdit = false;
      this.isShow = true;
    },
    // 编辑仓库名
    handlEdit(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }
      let { listData } = this;
      let filter = listData.filter((v) => v.id == id);
      this.name = filter[0].whname;
      this.editId = id;
      this.isShow = true;
      this.isEdit = true;
    },

    // 确认
    handleConfirm() {
      let { name, isEdit, qyid } = this;
      console.log(qyid, "=====");
      if (name === "") {
        this.$message.warning("请输入仓库名称");
        return;
      }
      if (!isEdit) {
        let params = {
          Method: "warehouseadd",
          whname: name,
          isuse: true,
          // qyid: qyid,
          openid: this.$store.state.OPENID,
        };
        this.loading = true;
        addWearhouse(params).then((res) => {
          if (res.result) {
            this.loading = false;
            this.isShow = false;
            this.init();
            // setTimeout(() => {
            //   this.init();
            //   this.$message.success(res.message);
            //   this.isShow = true;
            // }, 1000);
          } else {
            this.loading = false;
            this.$message.warning(res.message || "提交失败，请稍后重试！");
            this.isShow = false;
          }
        });
      } else {
        let params = {
          Method: "warehouseedit",
          whname: name,
          id: this.editId,
          isuse: true,
          qyid: qyid,
          openid: this.$store.state.OPENID,
        };
        this.loading = true;
        editWearhouse(params).then((res) => {
          if (res.result) {
            this.loading = false;
            this.isShow = false;
            this.init();
            // setTimeout(() => {
            //   this.$message.success(res.message);
            //   this.init();
            //   this.isShow = true;
            // }, 1000);
          } else {
            this.loading = false;
            this.$message.warning(res.message || "提交失败，请稍后重试！");
            this.isShow = false;
          }
        });
      }
    },

    handleGo(id) {
      this.$router.push(`/storageIndex/sManageTwo/${id}`);
    },

    // 返回
    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.storageManeagePage {
  .item_main_wrap {
    align-items: center;
  }
}
</style>